export default __webpack_public_path__ + "static/media/createClient-icon.8bb21622.svg";